import { BrowserModule } from '@angular/platform-browser'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, LOCALE_ID } from '@angular/core'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LayoutModule } from './layout/layout/layout.module'
import { LoginModule } from './login/login.module'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { TokenInterceptor } from './login/auth/token.interceptor'
import { CodeInputModule } from 'angular-code-input'
import { RouterModule } from '@angular/router'
import { NotificationBadgeService } from './content/support/services/notificationBadge.service'
import { HttpRequestInterceptor } from './service/loading/http-request-interceptor'
import { LoadingModule } from './service/loading/loading.module'
import { ToastService } from './service/toast/toast.service'
import { WebsocketService } from './service/Websocket/websocket.service'
import { ComponentsModule } from './components/components.module'
import { MatMenuModule } from '@angular/material/menu'
import { MatDialogModule } from '@angular/material/dialog'
import { SharedModule } from './shared/shared.module'
import { StateService } from './services/state.service'
import { QuillModule } from 'ngx-quill'
import { IconImageService } from './shared/services/icon-image.service'
import { ToastServiceV2 } from './shared/services/toast-v2/toast-v2.service'
import localeDa from '@angular/common/locales/da'
import { registerLocaleData } from '@angular/common'

registerLocaleData(localeDa)
@NgModule({
  declarations: [AppComponent],
  exports: [MatMenuModule, MatDialogModule],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [SharedModule, QuillModule.forRoot(), BrowserModule, LoginModule, NgbModule, LayoutModule, LoginModule, ReactiveFormsModule, BrowserAnimationsModule, AppRoutingModule, FormsModule, MatMenuModule, CodeInputModule, RouterModule, FormsModule, LoadingModule, ComponentsModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    NotificationBadgeService,
    ToastService,
    WebsocketService,
    StateService,
    IconImageService,
    ToastServiceV2,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor() {
    registerLocaleData(localeDa)
  }
}
